import { render, staticRenderFns } from "./new-application.vue?vue&type=template&id=472d9bc5&scoped=true"
import script from "./new-application.vue?vue&type=script&lang=js"
export * from "./new-application.vue?vue&type=script&lang=js"
import style0 from "./new-application.vue?vue&type=style&index=0&id=472d9bc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d9bc5",
  null
  
)

export default component.exports